<template>
    <va-create-layout>
        <ShipmentEventShipmentFee-form
            :title="title"
            :item="item"
        ></ShipmentEventShipmentFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
